var chunkToChildrenMap = {
	"9876": [
		9804,
		6261,
		3590,
		3591,
		4034,
		6182,
		7988,
		9589,
		5589,
		1905,
		8047,
		3524,
		9532,
		8268,
		1925
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));